var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagTibet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4307C24.8366 32.4307 32 25.2672 32 16.4307C32 7.59411 24.8366 0.430664 16 0.430664C7.16344 0.430664 0 7.59411 0 16.4307C0 25.2672 7.16344 32.4307 16 32.4307Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98242 3.21329C9.55023 1.45791 12.6551 0.430664 16.0004 0.430664C19.3456 0.430664 22.4505 1.45791 25.0183 3.21329L16.0004 3.90891L6.98242 3.21329Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68713 27.7436L12.0647 20.3661L16 13.6481L19.9348 20.3657L27.3129 27.7436C30.2085 24.8484 32 20.8491 32 16.4308C32 10.9394 29.2332 6.09482 25.0179 3.21338H6.98206C2.76681 6.09482 0 10.9394 0 16.4308C0 20.8491 1.7915 24.8484 4.68713 27.7436Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7841 22.5573L19.0859 17.71L19.9338 20.3652L27.3124 27.7438C28.7857 26.2708 29.9731 24.5119 30.7841 22.5573Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16.4305C32 14.2602 31.5674 12.1911 30.7845 10.3042L16 16.4305H32Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3129 5.11788C26.6096 4.41475 25.8416 3.77644 25.0179 3.21338H21.477L16 16.4308L27.3129 5.11788Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 3.21338H10.5234L16.0004 16.4308V3.21338Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68738 5.11768C3.21413 6.5908 2.02682 8.34961 1.21582 10.3042L16.0003 16.4306L4.68738 5.11768Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.4307C0 18.601 0.432562 20.67 1.2155 22.557L16 16.4307H0Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98242 29.6479C9.55017 31.4033 12.6551 32.4306 16.0004 32.4306C19.3456 32.4306 22.4505 31.4033 25.0183 29.6479H6.98242Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0007 16.4304L19.9359 20.3656C20.9431 19.3585 21.566 17.9672 21.566 16.4304C21.566 13.3568 19.0744 10.8652 16.0008 10.8652C12.9272 10.8652 10.4355 13.3568 10.4355 16.4304C10.4355 17.9672 11.0584 19.3585 12.0656 20.3656L16.0007 16.4304Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4352 24.4304C18.4352 25.7751 17.345 26.1695 16.0004 26.1695C14.6557 26.1695 13.5656 25.7751 13.5656 24.4304C13.5656 23.0857 14.6557 21.9956 16.0004 21.9956C17.345 21.9956 18.4352 23.0857 18.4352 24.4304Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4348 24.4307C18.4348 25.7754 17.3446 26.8655 16 26.8655C14.6554 26.8655 13.5652 25.7754 13.5652 24.4307",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16656"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.430664)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagTibet);
export default __webpack_public_path__ + "static/media/flag_tibet.1b27f6374c51264c58a10fadee55cb4d.svg";
export { ForwardRef as ReactComponent };